@let currentStatusValue = currentStatus();
@let currentConfigValue = currentConfig();
@let isPreonboardingValue = isPreonboarding();

@if (currentConfigValue.action) {
  <div class="actions">
    <rt-button
      (click)="actionClicked.emit(isPreonboardingValue ? 'preonboarding' : currentStatusValue)"
      [variant]="currentConfigValue.action.variant"
      margin-right-small-x
    >
      <rt-icon [name]="currentConfigValue.action.icon" />
      <span>{{ currentConfigValue.action.text }}</span>
    </rt-button>
  </div>
}
